<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>

        <v-layout wrap>
          <v-flex class="md4 pb-0">
            <v-text-field
              class="green-input search-input"
              label="Search by user name, mobile, type, transaction id..."
              color="green"
              v-model="searchTerm"              
          /></v-flex>
          <v-flex class="md3 pt-4">
              <date-picker placeholder="Search by date (range)" range v-model="date"></date-picker>
          </v-flex>
          <v-flex class="md4 pt-1 pull-left">
               <v-btn
                class="mx-0 font-weight-light"
                color="success" @click="getPaymentList">Search</v-btn>
               <v-btn
                class="mx-0 font-weight-light" style="margin-left:5px !important"
                color="warning" @click="onClearButtonClick">Clear</v-btn>
          </v-flex>
        </v-layout>
 
        <material-card color="green" title="All Payments">
          <v-data-table :headers="headers" :items="paymentList">
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.item_type }}</td>
              <td>{{ item.item_name }}</td>
              <td>{{ item.paid_amount }} BDT</td>
              <td>{{ item.transaction_id }}</td>
              <!-- <td>{{ item.status }}</td> -->
              <td>{{ item.card_type }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.transaction_status }}</td>              
            </template>
          </v-data-table>
        </material-card>

        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div>{{ noticeMessage }}</div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Form from "@/views/Form";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    DatePicker,
    Form
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState("userAllPayment", [
      "paymentList",
    ]),
  },
  mounted() {
    this.getPaymentList();
  },
  data() {
    return {
      date: null,
      valid: true,
      userPayment: {},
      makePayment: {},
      searchTermStudent: "",
      isSearchStudent :false,
      foundStudent: {},
      color: null,
      searchTerm: "",
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      dialogPayment: false,
      disableButton :false,
      dialogMakePayment: false,
      courseIDRules: [(v) => !!v || "Course is required."],
      pamentMethodRules: [(v) => !!v || "Payment Method is required."],
      transactionIdRules: [(v) => !!v || "Transaction Id is required."],
      amountRules: [(v) => !!v || "Amount is required."],
      pamentMethodList: [
        { id: "bKash", name: "bKash" },
        { id: "Rocket", name: "Rocket" }
      ],
      statusList: [
        { id: "Pending", name: "Pending" },
        { id: "Enrolled", name: "Enrolled" },
        { id: "Cancel", name: "Cancel" },
      ],
      headers: [
        {
          sortable: true,
          text: "User Name",
          value: "user_name",
        },
        {
          sortable: true,
          text: "Mobile",
          value: "mobile",
        },
        {
          sortable: false,
          text: "Type",
          value: "item_type",
        },
        {
          sortable: false,
          text: "Item",
          value: "item",
        },
        {
          sortable: false,
          text: "Amount",
          value: "amount",
        },
        {
          sortable: false,
          text: "Transaction Id",
          value: "transaction_id",
        },
        // {
        //   sortable: false,
        //   text: "Item Status",
        //   value: "item_status",
        // },
        {
          sortable: false,
          text: "Method",
          value: "method",
        },
        {
          sortable: false,
          text: "Purchased Date",
          value: "purchased_pate",
        },
        {
          sortable: false,
          text: "Transaction Status",
          value: "transaction_status",
        }    
      ],

      noticeMessage: "",
      valueObj: {},
    };
  },
  created() {},
  methods: {
    ...mapActions("userAllPayment", [
      "getUserTransactionList"   
    ]),

 
  onClearButtonClick (event) {
      this.searchTerm = null;    
      this.date = null;  
      this.getPaymentList();  
    },
  getPaymentList() {
    let from_date = null;
    let to_date = null;
    if(this.date){
      from_date = this.date[0] ? this.date[0] : null;
       to_date = this.date[1] ? this.date[1] : null;
    }
       

      let obj = {
        search_item: this.searchTerm,
        from: from_date,
        to: to_date
      };
      console.log(obj);
      const response = this.getUserTransactionList(obj);
    },


    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snackbar = true;
    },
  },
};
</script>
